<template>
    <main class="main" id="main">
        <navigate></navigate>
        <section class="section s-lk">
            <div class="container">
                <div class="referal_monitor_box">
                    <div class="header">
                        <span>Выберите период</span>
                        <input type="text" name="datetimes" id="stats_range" class="range_input"/>

                    </div>
                    <table class="table_restaurants" id="table_restaurants">
                        <thead>
                        <tr class="row">
                            <th>Город</th>
                            <th>Партнёр</th>
                            <th>Перевести<br><span>руб</span></th>
                            <th>Приглашенных<br><span>чел</span></th>
                            <th>Баланс<br><span>руб</span></th>
                            <th>Выплачено<br><span>руб</span></th>
                            <th>Заработано<br><span>руб</span></th>
                            <th>Сумма<br><span>заказы, руб</span></th>
                            <th>Принятые<br><span>заказы, руб</span></th>
                            <th>Отмененные<br><span>заказы, руб</span></th>
                            <th>Завершенные<br><span>заказы, руб</span></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="row" v-show="currentRef === null || currentRef === id" v-for="(user, id) in data" :key="id">
                            <td class="td" @click="currentRef = id">{{user.city}}</td>
                            <td class="td" @click="currentRef = id">{{user.email}}</td>
                            <td class="td" v-if="user.money && user.wait">{{user.wait}}
                                <button class="doc_btn" @click="sendUser = user.payData">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/send.svg" alt="">
                                </button>
                            </td>
                            <td class="td" v-else></td>
                            <td class="td" @click="currentRef = id">{{user.count}}</td>
                            <td class="td" @click="currentRef = id">{{user.money}}</td>
                            <td class="td" @click="currentRef = id">{{user.pay}}</td>
                            <td class="td" @click="currentRef = id">{{user.sum}}</td>
                            <td class="td" @click="currentRef = id">{{user.orders.sum}}</td>
                            <td class="td" @click="currentRef = id">{{user.orders[2]}}</td>
                            <td class="td" @click="currentRef = id">{{user.orders[5]}}</td>
                            <td class="td" @click="currentRef = id">{{user.orders[4]}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
        <div class="lk-popup wallet" v-if="sendUser" style="position: fixed; left: 50%; top: 50%; z-index: 999; transform: translate(-50%, -50%);width: 40vh;min-width: 500px;max-width: 600px;">
            <div class="title">
                <i class="fas fa-times close" @click="sendUser = null"></i>
            </div>
            <div class="content_box">
                <div class="wallet_item" v-if="sendUser.payType === 'visa'">
                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/visa.svg" alt="">
                    <h2>{{sendUser.pay}}</h2>
                </div>
                <div class="wallet_item" v-else-if="sendUser.payType === 'yandex'">
                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/yandex.svg" alt="">
                    <h2>{{sendUser.pay}}</h2>
                </div>
                <div class="wallet_item" v-else>
                    <h2>{{sendUser.pay}}</h2>
                </div>
                <h3>Баланс пользователя: {{sendUser.money}} руб<br>Ожидает вывода: {{sendUser.wait}} руб</h3>
                <button class="menu_item_btn green" @click="sendMoney">Подтвердить оплату по указанным выше реквизитам</button>
            </div>
        </div>
        <section class="section s-lk" v-if="currentRef">
            <div class="container">
                <div class="referal_monitor_box" style="position:relative;">
                <h1>Рефералы {{data[currentRef].email}}</h1>
                <button @click="currentRef = null" style="position: absolute;right: 10px;top: 20px;">Закрыть</button>
                <div class="statistic_table_box">
                    <table class="table_restaurants" id="table_restaurants2">
                        <thead>
                        <tr class="row">
                            <th>Пользователь</th>
                            <th>Регистрация</th>
                            <th>Город</th>
                            <th>Сумма<br><span>заказы, руб</span></th>
                            <th>Доход<br><span>руб</span></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="row" v-for="(user, id) in data[currentRef].users" :key="id">
                            <td class="td">{{user.email}}</td>
                            <td class="td">{{user.date}}</td>
                            <td class="td">{{user.city}}</td>
                            <td class="td">{{user.orders}}</td>
                            <td class="td">{{user.sum}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import $ from 'jquery'
import navigate from '@/pages/lk/user/navigate'
import moment from 'moment'
import axios from '@/router/http'
import 'datatables'
import 'datatables/media/css/jquery.dataTables.css'
import 'daterangepicker/daterangepicker'
import 'daterangepicker/daterangepicker.css'
export default {
  name: 'userReferral',
  props: ['city', 'auth', 'geo', 'user'],
  data () {
    return {
      range: {},
      data: {},
      currentRef: null,
      sendUser: null
    }
  },
  components: {
    navigate
  },
  created () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  },
  mounted () {
    $('#stats_range').daterangepicker({
      language: 'ru',
      alwaysShowCalendars: true,
      ranges: {
        'Сегодня': [moment(), moment()],
        'Вчера': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'За последние 7 дней': [moment().subtract(6, 'days'), moment()],
        'За последние 30 дней': [moment().subtract(29, 'days'), moment()],
        'В этом месяце': [moment().startOf('month'), moment().endOf('month')],
        'В прошлом месяце': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      'locale': {
        'format': 'MM/DD/YYYY',
        'separator': ' - ',
        'applyLabel': 'Принять',
        'cancelLabel': 'Отменить',
        'fromLabel': 'От',
        'toLabel': 'До',
        'customRangeLabel': '',
        'weekLabel': 'Н',
        'daysOfWeek': [
          'Вс',
          'Пн',
          'Вт',
          'Ср',
          'Чт',
          'Пт',
          'Сб'
        ],
        'monthNames': [
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Сентябрь',
          'Октябрь',
          'Ноябрь',
          'Декабрь'
        ],
        'firstDay': 1
      }
    }, (start, end, label) => {
      this.range = {
        start: start.format('YYYY-MM-DD'),
        end: end.format('YYYY-MM-DD')
      }
      this.currentCity = null
    })
  },
  methods: {
    sendMoney () {
      var formData = new FormData()
      formData.append('id', this.sendUser.id)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/send-money-approve',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.sendUser = null
        alert('Вывод средств успешно подтвержден')
      })
    },
    initAjax () {
      axios.get('https://lk.when-hungry.com/mobile/get-referrals?uid=' + this.auth.uid).then(response => {
        this.data = response.data
      })
    }
  },
  watch: {
    data () {
      if ($('#table_restaurants.dataTable').length) $('#table_restaurants').DataTable().destroy()
      setTimeout(() => {
        $('#table_restaurants').DataTable({
          'order': [[ 2, 'desc' ]],
          'language': {
            'decimal': '',
            'emptyTable': 'No data available in table',
            'info': 'С _START_ до _END_ из _TOTAL_ записей',
            'infoEmpty': 'С 0 до 0 из 0 записей',
            'infoFiltered': '(filtered from _MAX_ total entries)',
            'infoPostFix': '',
            'thousands': ',',
            'lengthMenu': 'Выводить по _MENU_',
            'loadingRecords': 'Loading...',
            'processing': 'Processing...',
            'search': 'Поиск:',
            'zeroRecords': 'No matching records found',
            'paginate': {
              'first': 'First',
              'last': 'Last',
              'next': 'След',
              'previous': 'Пред'
            },
            'aria': {
              'sortAscending': ': activate to sort column ascending',
              'sortDescending': ': activate to sort column descending'
            }
          },
          'scrollX': true,
          fixedHeader: {
            header: true
          }
        })
      }, 300)
    },

    currentRef (val, oldVal) {
      if (val && val !== oldVal) {
        if ($('#table_restaurants2.dataTable').length) $('#table_restaurants2').DataTable().destroy()
        setTimeout(() => {
          $('#table_restaurants2').DataTable({
            'language': {
              'decimal': '',
              'emptyTable': 'No data available in table',
              'info': 'С _START_ до _END_ из _TOTAL_ записей',
              'infoEmpty': 'С 0 до 0 из 0 записей',
              'infoFiltered': '(filtered from _MAX_ total entries)',
              'infoPostFix': '',
              'thousands': ',',
              'lengthMenu': 'Выводить по _MENU_',
              'loadingRecords': 'Loading...',
              'processing': 'Processing...',
              'search': 'Поиск:',
              'zeroRecords': 'No matching records found',
              'paginate': {
                'first': 'First',
                'last': 'Last',
                'next': 'След',
                'previous': 'Пред'
              },
              'aria': {
                'sortAscending': ': activate to sort column ascending',
                'sortDescending': ': activate to sort column descending'
              }
            },
            'scrollX': true,
            fixedHeader: {
              header: true
            }
          })
        }, 300)
      }
    }
  }
}
</script>

<style scoped>

    .close {
        position: absolute;
        right: 20px;
        top: 20px;
        font-size: 30px;
        opacity: 0.8;
        cursor: pointer;
        z-index: 9999;
    }
    .close:hover {
        opacity: 0.4;
    }
</style>



// WEBPACK FOOTER //
// src/pages/lk/user/referral.vue